import CodeJobTypeList from "./pages/ListPage.vue";
import CodeJobTypeDetail from "./pages/FormPage.vue";
import CodeJobTypeIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/code_job_type",
    component: CodeJobTypeIndex,
    redirect: "/code_job_type/list",
    name: "code_job_type",
    children: [
      {
        path: "list",
        component: CodeJobTypeList,
        name: "code_job_type.list",
      },
      {
        path: "create",
        component: CodeJobTypeDetail,
        name: "code_job_type.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeJobTypeDetail,
        name: "code_job_type.edit",
        props: { create: false },
      },
    ],
  },
];
